<template>

	<div class='add-block'>
		<div class='flex-container'>

			<div class='flex-item'>
				<span class='label'>Категория состояния</span>
				<custom-p-select
					v-model='values.state_cat'
					:options='filteredList'
					optionLabel='state_cat'
				/>
			</div>

			<div class='flex-item'>
				<span class='label'>Причина</span>
				<custom-p-select
					v-model='values.reason'
					:options='damageReasonList'
				/>
			</div>

			<div class='flex-item'>
				<span class='label'>Признак</span>
				<custom-p-select
					v-model='values.symptom'
					:options='damageSymptomList'
				/>
			</div>

			<div class='flex-item'>
				<span class='label'>Доля от запаса породы, %</span>
				<input v-model='values.symptom_proc' class='input-common'>
			</div>

			<div class='flex-item'>
				<button @click='close'>Закрыть</button>
				<button @click='save'>Сохранить</button>
			</div>

		</div>
	</div>
		
</template>

<script>
	import { mapState, mapMutations, mapActions } from 'vuex';

	const ROOT_API = process.env.VUE_APP_ROOT_API;

	const GET_DAMAGE_REASONS = ROOT_API + 'get_site_data/get_damage_reasons_by_species.php';
	const GET_DAMAGE_SYMPTOMS = ROOT_API + 'get_site_data/get_damage_symptoms_by_reason_and_state_cat.php';

	export default {
		name: 'RecountVbSheetDamagesAddBlock',
		props: {
			currentSpecies: {
				type: Object,
				default: null
			},
		},
		data: () => ({
			values: {
				state_cat: null,
				reason: null,
				symptom: null,
				symptom_proc: null,
			},

			damageReasonList: [],
			damageSymptomList: [],
		}),
		computed: {
			value_reason() {
				return this.values.reason;
			},

			value_state_cat() {
				return this.values.state_cat;
			},

			filteredList() {
				const filtered = this.currentSpecies.state_cats.filter(element => element.state_cat_id !== '1');
				return filtered;
			},

			...mapState('selectedLpo/recount', {
				vbList: state => state['vbList']
			})
		},

		watch: {
			value_reason(value_reason) {
				if (!value_reason || value_reason.id === null) {
					this.values.symptom = null;
					this.damageSymptomList = [];
				} else if (!this.value_state_cat || this.value_state_cat.id === null) {
					this.values.symptom = null;
					this.damageSymptomList = [];
				} else if (this.value_state_cat) {
					this.getDamageSymptomList();
				}
			},
			value_state_cat(value_state_cat) {
				if (!value_state_cat || value_state_cat.id === null) {
					this.values.symptom = null;
					this.damageSymptomList = [];
				} else if (!this.value_reason || this.value_reason.id === null) {
					this.values.symptom = null;
					this.damageSymptomList = [];
				} else if (this.value_reason) {
					this.getDamageSymptomList();
				}
			}
		},

		methods: {
			save() {
				if (this.values.state_cat === null) {
					this.$toast.add({severity: 'warn', detail: 'Необходимо указать категорию состояния', life: 10000});
					return;
				}
				if (this.values.reason === null) {
					this.$toast.add({severity: 'warn', detail: 'Необходимо указать причину повреждения', life: 10000});
					return;
				}
				if (this.values.symptom === null) {
					this.$toast.add({severity: 'warn', detail: 'Необходимо указать признак повреждения', life: 10000});
					return;
				}
				if (this.values.symptom_proc === null || this.values.symptom_proc === '') {
					this.$toast.add({severity: 'warn', detail: 'Необходимо указать долю повреждения', life: 10000});
					return;
				}

				if (+this.values.symptom_proc <= 0) {
					this.$toast.add({severity: 'warn', detail: 'Доля повреждения не может быть нулем или отрицательным значением', life: 10000});
					return;
				}

				if (+this.values.symptom_proc > +this.values.state_cat.trees_proc) {
					this.$toast.add({severity: 'warn', detail: 'Доля повреждения не может превышать долю деревьев данной категории', life: 10000});
					return;
				}

				this.values.species = this.currentSpecies.info;

				this.saveVbDamage(this.values).then(res => {
					this.updateVbList();
				});
			},

			close() {
				this.$emit('close');
			},

			getDamageReasonList() {
				const form = new FormData();
				form.append('species_id', this.currentSpecies.info.species_id);

				fetch(GET_DAMAGE_REASONS, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					this.damageReasonList = res;
				})
				.catch(err => { throw err });
			},

			getDamageSymptomList() {
				const form = new FormData();
				form.append('reason_id', this.values.reason.id);
				form.append('state_cat_id', this.values.state_cat.state_cat_id);

				fetch(GET_DAMAGE_SYMPTOMS, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					this.damageSymptomList = res;
				})
				.catch(err => { throw err });
			},

			...mapActions('selectedLpo/recount', [
				'saveVbDamage',
				'updateVbList'
			]),

		},

		created() {
			this.getDamageReasonList();
		}

	};
</script>

<style scoped src='@/style/flex.css'></style>
<style scoped src='@/style/input.css'></style>

<style scoped>

	.add-block {
		border: 1px solid black;
		padding: 10px 20px;
		margin: 10px 0;
	}

	.flex-container {
		gap: 10px;
		/*flex-wrap: nowrap;*/
	}

	.table-add-damage {
		width: 100%;
	}

	.table-add-damage td {
		padding: 4px 10px;
		width: 20%;
		min-width: 20%;
		max-width: 20%;
	}

</style>